import { basicBorder, getTextColor, getYiq } from "helpers/tags";

// Select choices are stored as `{ value, color }` on the column's options; rows
// hold only the value, so a color is always looked up from the column.
export const DEFAULT_CHOICE_COLOR = "#E8E8E8";

// Same threshold the tag chips use: very light colors need a border to stay
// visible against the white grid.
const LIGHT_COLOR_YIQ = 225;

export const choiceChipStyle = color => ({
  backgroundColor: color,
  color: getTextColor(color),
  border: getYiq(color) >= LIGHT_COLOR_YIQ ? basicBorder : undefined,
});

export const choiceValues = options =>
  (options?.choices ?? []).map(c => c.value);

export const choiceColor = (options, value) =>
  options?.choices?.find(c => c.value === value)?.color ?? DEFAULT_CHOICE_COLOR;

// Rebuilds the choice list after a value-only edit, keeping each surviving
// choice's color and giving new values the default color.
export const choicesForValues = (choices, values) => {
  const colorByValue = new Map(choices.map(c => [c.value, c.color]));
  return values.map(value => ({
    value,
    color: colorByValue.get(value) ?? DEFAULT_CHOICE_COLOR,
  }));
};
